//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../GeometricUtilities/GeometricUtilities.CurveFitData.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[1,"ConstraintFaces",0,"ScCollector",1],[1,"CurveFitData",0,"GeometricUtilities.CurveFitData",1],[0,"CurveFitOption",1,1],[1,"Depth",0,"Expression",1],[0,"EndContinuityOption",1,1],[0,"EndCurveDirectionOption",1,1],[1,"EndDirectionAngle",0,"Expression",1],[1,"EndObject",0,"SelectObject",1],[0,"EndObjectOption",1,1],[1,"EndPerpendicularFace",0,"SelectObject",1],[0,"EndPointDirection",1,"Direction",1],[0,"EndReferencePoint",1,"Point",1],[0,"EndSurfaceDirectionOption",1,1],[1,"EndTangentMagnitude",0,"Expression",1],[0,"EndVectorObject",1,"Direction",1],[0,"IsAssociative",1,1],[0,"MaximumDegree",1,1],[0,"MaximumSegment",1,1],[0,"MinimumRadiusOption",1,1],[1,"MinimumRadiusValue",0,"Expression",1],[0,"ObjectSelectionOption",1,1],[0,"ReverseEndDirection",1,1],[0,"ReverseStartDirection",1,1],[1,"Rho",0,"Expression",1],[0,"ShapeControlOption",1,1],[1,"ShapeCurve",0,"SelectObject",1],[1,"Skew",0,"Expression",1],[0,"StartContinuityOption",1,1],[0,"StartCurveDirectionOption",1,1],[1,"StartDirectionAngle",0,"Expression",1],[1,"StartObject",0,"SelectObject",1],[1,"StartPerpendicularFace",0,"SelectObject",1],[0,"StartPointDirection",1,"Direction",1],[0,"StartReferencePoint",1,"Point",1],[0,"StartSurfaceDirectionOption",1,1],[1,"StartTangentMagnitude",0,"Expression",1],[0,"Tolerance",1,1],[1,"UPercentEnd",0,"Expression",1],[1,"UPercentStart",0,"Expression",1],[1,"VPercentEnd",0,"Expression",1],[1,"VPercentStart",0,"Expression",1]],[],[]];
SPLM.Features.BridgeCurveBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.BridgeCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.BridgeCurveBuilder.EndObjectTypes = Object.freeze({
    "Object" : "Object", "Vector" : "Vector"});

SPLM.Features.BridgeCurveBuilder.SelectedObject = Object.freeze({
    "One" : "One", "Two" : "Two"});

SPLM.Features.BridgeCurveBuilder.ConstraintTypes = Object.freeze({
    "G0" : "G0", "G1" : "G1", "G2" : "G2", "G3" : "G3"});

SPLM.Features.BridgeCurveBuilder.CurveDirectionTypes = Object.freeze({
    "Tangent" : "Tangent", "Perpendicular" : "Perpendicular"});

SPLM.Features.BridgeCurveBuilder.SurfaceDirectionTypes = Object.freeze({
    "Sectional" : "Sectional", "IsoU" : "IsoU", "IsoV" : "IsoV"});

SPLM.Features.BridgeCurveBuilder.MinRadiusTypes = Object.freeze({
    "None" : "None", "Minimum" : "Minimum", "Peak" : "Peak"});

SPLM.Features.BridgeCurveBuilder.ShapeControlTypes = Object.freeze({
    "EndPoint" : "EndPoint", "PeakPoint" : "PeakPoint", "Conic" : "Conic", "ShapeCurve" : "ShapeCurve"});

SPLM.Features.BridgeCurveBuilder.CurveFitTypes = Object.freeze({
    "Cubic" : "Cubic", "Quintic" : "Quintic", "Advanced" : "Advanced"});

export default SPLM;